import { Injectable, OnDestroy } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { OperationsBookingData, OperationsBookingType } from "@core/models/operations-email";
import { buildOperationsEmailDetails, buildOperationsEmailText } from "./operations-email";
import { ConfigService } from "@core/services/config.service";
import { Agency, Company, Config, Hub } from "@models";
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { AppState } from "app/app.reducer";
import * as CryptoJS from "crypto-js";
import * as moment from "moment";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { stringSimilarity } from "string-similarity-js";
import { BookedService } from "./booked.service";
import { NgxToastrService } from "./ngx.toastr.service";
import { io } from "socket.io-client";
import { environment } from "@env/environment";

@Injectable({
  providedIn: "root",
})
export class UtilsService implements OnDestroy {
  configHotels: Config;
  configFlights: Config;
  getConfigsubscription: Subscription[] = [];
  maxHotelPercentage;
  maxFlightPercentage;
  loadingFlights = false;
  reloadingFlights = false;
  loadingTrains = false;
  loadingHotels = false;
  isLoading = false;
  letItGoTimer = 10000;
  haveRequest = false;
  bookeds: any[] = [];
  secretAESKey = "e34a7203f57bc250b6336dc6a1bfeca2"; // "Vy00tR1p" in md5
  imageChanged$ = new Subject<string>();
  userChanged$ = new Subject<boolean>();
  allLoaded = false;
  nearbyDeparture: boolean;
  nearbyArrival: boolean;
  userBookingsFilters = {
    fromDate: null,
    toDate: null,
    createdFromDate: null,
    createdToDate: null,
  };
  socket = io(environment.socketUrlApi);
  private reloadSubject = new Subject<void>();
  reload$ = this.reloadSubject.asObservable();
  correlationId: string[] = [];
  selectedUsers: any[] = [];
  bookingInfo: any = {};
  hotel: any;
  selectedRooms: any[] = [];
  private backNavigation = false;
  private processedUuids: Set<string> = new Set();
  private projectData: { selectedProject: any, allProjects: any[] } = { selectedProject: null, allProjects: [] };
  private userSubject = new BehaviorSubject<any>(null);
  user$ = this.userSubject.asObservable();
  isPackageRate: string;

  constructor(
    private ngbDateParser: NgbDateParserFormatter,
    private bookingService: BookedService,
    private configService: ConfigService,
    private translate: TranslateService,
    private ngxToastrService: NgxToastrService,
    private store: Store<AppState>,
    private router: Router
  ) {
    this.getConfigsubscription.push(
      this.store
        .select("auth")
        .pipe(take(1))
        .subscribe((auth) => {
          if (auth.user && auth.user.type?.toUpperCase() === "EMPLOYEE") {
            this.getPercentages();
          }
        })
    );
  }

  triggerReload() {
    this.reloadSubject.next();
  }

  getInDate(maxDateNgStruct, checkOut) {
    const date = checkOut ? checkOut : maxDateNgStruct;
    const dateMoment = moment(
      this.ngbDateParser.format(date),
      "DD/MM/YYYY"
    ).add(-1, "days");
    const ngbStruct: NgbDateStruct = {
      year: dateMoment.year(),
      month: dateMoment.month() + 1,
      day: dateMoment.date(),
    };
    return ngbStruct;
  }

  getOutDate(minDateNgStruct, checkIn) {
    const date = checkIn ? checkIn : minDateNgStruct;
    const dateMoment = moment(
      this.ngbDateParser.format(date),
      "DD/MM/YYYY"
    ).add(1, "days");
    const ngbStruct: NgbDateStruct = {
      year: dateMoment.year(),
      month: dateMoment.month() + 1,
      day: dateMoment.date(),
    };
    return ngbStruct;
  }

  getOutDateSame(minDateNgStruct, checkIn) {
    const date = checkIn ? checkIn : minDateNgStruct;
    const dateMoment = moment(this.ngbDateParser.format(date), "DD/MM/YYYY");
    const ngbStruct: NgbDateStruct = {
      year: dateMoment.year(),
      month: dateMoment.month() + 1,
      day: dateMoment.date(),
    };
    return ngbStruct;
  }

  departureBeforeReturn(dateDepartureAux, dateReturnAux, f) {
    const dateDeparture = moment(dateDepartureAux);
    const dateReturn = moment(dateReturnAux);
    if (dateReturn.isSame(dateDeparture)) {
      if (f.timeDeparture.value && f.timeReturn.value) {
        return f.timeDeparture.value.hour < f.timeReturn.value.hour;
      } else {
        return f.timeReturn.value && f.timeReturn.value.hour > 0;
      }
    } else {
      return true;
    }
  }

  toFormData(obj, form, namespace?) {
    const fd = form || new FormData();
    let formKey;
    if (obj["bookedWithoutCard"] === false) {
      fd.append("bookedWithoutCard", obj["bookedWithoutCard"]);
    }
    for (const property in obj) {
      if (obj.hasOwnProperty(property) && obj[property]) {
        if (namespace) {
          formKey = namespace + "[" + property + "]";
        } else {
          formKey = property;
        }

        // if the property is an object, but not a File, use recursivity.
        if (obj[property] instanceof Date) {
          fd.append(formKey, obj[property].toISOString());
        } else if (
          typeof obj[property] === "object" &&
          !(obj[property] instanceof File)
        ) {
          if (property === "suppliers" && Array.isArray(obj[property])) {
            for (let i = 0; i < obj[property].length; i++) {
              const arrayKey = formKey + "[" + i + "]";
              fd.append(arrayKey, obj[property][i]);
            }
          } else {
            this.toFormData(obj[property], fd, formKey);
          }
        } else {
          // if it's a string or a File object
          fd.append(formKey, obj[property]);
        }
      }
    }

    return fd;
  }

  editCompany(company: Company, isCompany: boolean, reloadCompanies?) {
    const extras: NavigationExtras = {
      state: {
        loading: false,
        company: company,
        maxHotelPercentage: 100,
        maxFlightPercentage: this.maxFlightPercentage,
        isCreate: false,
      },
    };

    this.router.navigate(
      ["companies/" + company.uuid + "/edit-company"],
      extras
    );
  }

  editAgency(agency: Agency, isAgency: boolean, reloadAgencies?) {
    const navigationExtra: NavigationExtras = {
      state: {
        agency: agency,
        loading: false,
        maxHotelPercentage: this.maxHotelPercentage,
        maxFlightPercentage: this.maxFlightPercentage,
      },
    };
    this.router.navigate([`/agencies/${agency.uuid}/edit`], navigationExtra);
  }

  editHub(hub: Hub, isHub: boolean, reloadHubs?) {
    const navigationExtras: NavigationExtras = {
      state: {
        hub: hub,
        loading: false,
      },
    };
    this.router.navigate([`/hubs/${hub.uuid}/edit`], navigationExtras);
  }

  getPercentages() {
    this.getConfigsubscription.push(
      this.configService.getPercentageVyoo("percentageCompany").subscribe(
        (data: Config) => {
          this.configHotels = data;
          if (!this.configHotels.value) {
            this.configHotels.value = [17];
          }
          this.maxHotelPercentage = this.configHotels.value
            ? this.configHotels.value[0]
            : 17;
        },
        (err) => {
          this.ngxToastrService.typeInfo(
            "Error",
            this.translate.instant("common.some-error")
          );
        }
      ),
      this.configService.getPercentageVyoo("flightCommissions").subscribe(
        (data: Config) => {
          this.configFlights = data;
          if (!this.configFlights.value) {
            this.configFlights.value = [
              {
                local_emission: 5,
                eu_emission: 7,
                world_emission: 9,
                percentage: 5,
              },
            ];
          }

          this.maxFlightPercentage = this.configFlights.value[0].percentage;
        },
        (err) => {
          this.ngxToastrService.typeInfo(
            "Error",
            this.translate.instant("common.some-error")
          );
        }
      )
    );
  }

  sendEmailOperations(type: OperationsBookingType, data: OperationsBookingData, userUuid?: string) {
    const details = buildOperationsEmailDetails(type, data);
    this.getConfigsubscription.push(
      this.bookingService
        .sendEmailOperations({
          text: buildOperationsEmailText(details),
          details,
          userUuid: userUuid ? (Array.isArray(userUuid) ? userUuid[0] : userUuid) : null,
        })
        .subscribe(() => {
          return;
        })
    );
  }

  sortArrayByDate(array: any) {
    const sortedArray: any = array.sort((a, b) => {
      if (a.createdAt > b.createdAt) {
        return -1;
      }
      if (a.createdAt < b.createdAt) {
        return 1;
      }
      return 0;
    });
    return sortedArray;
  }

  sortArrayByAlphabet(array: any) {
    const sortedArray: any = array.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return sortedArray;
  }

  encrypt(value: any) {
    return CryptoJS.AES.encrypt(value, this.secretAESKey);
  }

  generateRedsysToken(cardData) {
    return this.encrypt(JSON.stringify(cardData));
  }

  decrypt(value: any) {
    const decrypted = CryptoJS.AES.decrypt(value, this.secretAESKey);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  getUuidTracking(index: number, item: any) {
    if (item.uuid != null) {
      return item.uuid;
    } else {
      console.log("uuid not found");
    }
  }

  storeParamInLocalStorageNoEncrypt(param: { title: string; value: any }) {
    const value = param.value;
    localStorage.setItem(param.title, JSON.stringify({ value }).toString());
  }

  storeParamInLocalStorage(param: { title: string; value: any }) {
    const value = param.value;
    localStorage.setItem(
      param.title,
      this.encrypt(JSON.stringify({ value })).toString()
    );
  }

  getLocalStorageItem(key: string) {
    const item = localStorage.getItem(key);
    if (item == null || item === "undefined") {
      return null;
    }
    const decrypted = this.decrypt(item);
    if (decrypted !== "") {
      return JSON.parse(decrypted);
    } else {
      return item;
    }
  }

  removeItemFromLocalStorage(key: string) {
    localStorage.removeItem(key);
  }

  inputIsInList(value: string, list: string[]): number {
    const similarityIdxs = [];
    list.forEach((s) => {
      const similarityScore = stringSimilarity(value, s);
      similarityIdxs.push(similarityScore);
    });
    const maxIdx = similarityIdxs.indexOf(Math.max(...similarityIdxs));
    return maxIdx;
  }

  setSelectedUsers(users: any[]) {
    this.selectedUsers = users;
  }

  getSelectedUsers() {
    return this.selectedUsers;
  }

  setBookingInfo(info: any) {
    this.bookingInfo = info;
  }

  getBookingInfo() {
    return this.bookingInfo;
  }

  setHotelInfo(hotel: any) {
    this.hotel = hotel;
  }

  getHotelInfo() {
    return this.hotel;
  }

  setSelectedRooms(rooms: any[]) {
    this.selectedRooms = rooms;
  }

  getSelectedRooms() {
    return this.selectedRooms;
  }

  ngOnDestroy() {
    this.getConfigsubscription.forEach((s) => s.unsubscribe());
  }

  imageChanged(image: string) {
    this.imageChanged$.next(image);
  }

  userChanged() {
    this.userChanged$.next(true);
  }

  openChat() {
    window["HubSpotConversations"].widget.open();
  }

  setBackNavigation(state: boolean) {
    this.backNavigation = state;
  }

  isBackNavigation(): boolean {
    return this.backNavigation;
  }
  
  isAdmin(userType: string) {
    return userType === 'employee' || userType === 'company' || userType === 'agency' || userType === 'hub'
  }

  hasProcessedUuid(uuid: string): boolean {
    return this.processedUuids.has(uuid);
  }

  addProcessedUuid(uuid: string) {
    this.processedUuids.add(uuid);
  }

  clearProcessedUuids() {
    this.processedUuids.clear();
  }

  setProjectData(data: { selectedProject: any, allProjects: any[] }) {
    this.projectData = data;
  }

  getProjectData() {
    return this.projectData;
  }

  clearProjectData() {
    this.projectData = { selectedProject: null, allProjects: [] };
  }
  
  updateUser(user: any) {
    this.userSubject.next(user);
  }

  clearUserData() {
    this.userSubject.next(null);
  }

  getNavigationRoute(user?: any, company?: any, canUseTRM?: any): string {
    const companyUuid = company ? company.uuid : this.getLocalStorageItem("companyUuid")?.value
    const roleToRouteMap = {
      EMPLOYEE: companyUuid ? "/companies/" + companyUuid : "/companies/",
      AGENCY: companyUuid ? "/companies/" + companyUuid : "/companies/",
      HUB: companyUuid ? "/companies/" + companyUuid : "/companies/",
      COMPANY: "/my-company/details",
      USER: "/home"
    };
  
    const userType = user?.type?.toUpperCase();
    const accessType = user?.accessType?.toUpperCase();

    const isEmployee = userType === 'EMPLOYEE' || accessType === 'EMPLOYEE';

    if (!isEmployee && canUseTRM === false) {
      return "/home";
    }
    return roleToRouteMap[userType] || roleToRouteMap[accessType];
  }

  getValidationErrorMessage(error: any, type?: string): string {
    const fieldLabel = this.getValidationFieldLabel(error?.field, type);
    const errorType = error?.type;

    if (
      errorType === 'any.required' ||
      errorType === 'any.empty' ||
      errorType === 'string.empty'
    ) {
      return this.instantOrFallback(
        'common.validation.field-required',
        `El campo ${fieldLabel} es obligatorio`,
        { field: fieldLabel }
      );
    }

    if (errorType === 'number.base') {
      return this.instantOrFallback(
        'common.validation.field-number',
        `El campo ${fieldLabel} debe ser numérico`,
        { field: fieldLabel }
      );
    }

    if (
      errorType === 'boolean.base' ||
      errorType === 'string.guid' ||
      errorType === 'string.uuid' ||
      errorType === 'array.base' ||
      errorType === 'object.base'
    ) {
      return this.instantOrFallback(
        'common.validation.field-invalid',
        `El valor del campo ${fieldLabel} es incorrecto`,
        { field: fieldLabel }
      );
    }

    if (errorType === 'array.min') {
      return this.instantOrFallback(
        'common.validation.field-required',
        `El campo ${fieldLabel} es obligatorio`,
        { field: fieldLabel }
      );
    }

    return this.instantOrFallback(
      'common.validation.field-invalid',
      `El valor del campo ${fieldLabel} es incorrecto`,
      { field: fieldLabel }
    );
  }

  getValidationFieldLabel(field: string, type?: string): string {
    const normalizedField = this.normalizeValidationField(field);

    const serviceType = type || 'train';

    const fieldTranslationMap: Record<string, string> = {
      companyUuid: 'company.company',
      userUuid: 'common.user',
      from: `${serviceType}.form-${serviceType}.origin`,
      to: `${serviceType}.form-${serviceType}.destination`,
      departDate: serviceType === 'car' ? 'car.custom.request.departDate' : `${serviceType}.form-${serviceType}.date-departure`,
      returnDate: serviceType === 'car' ? 'car.custom.request.returnDate' : `${serviceType}.form-${serviceType}.date-return`,
      origin: `${serviceType}.form-${serviceType}.origin`,
      destination: `${serviceType}.form-${serviceType}.destination`,
      dateDeparture: `${serviceType}.form-${serviceType}.date-departure`,
      dateReturn: `${serviceType}.form-${serviceType}.date-return`,
      timeDeparture: 'custom-service.train-flight.departure',
      timeReturn: 'custom-service.train-flight.return',
      notes: `${serviceType}.form-${serviceType}.annotations`,
      annotations: serviceType === 'user'
        ? 'flight.form-flight.annotations'
        : `${serviceType}.form-${serviceType}.annotations`,
      traveller: 'common.traveller',
      travellersCount: 'flight.form-flight.travellers-number',
      travellers: 'common.traveller',
      destinationName: serviceType === 'airbnb'
        ? 'airbnb.create-airbnb.ubication'
        : 'hotel.custom.city',
      address: 'common.address',
      hotelName: serviceType === 'airbnb'
        ? 'airbnb.custom.request.link'
        : 'hotel.custom.hotel-name',
      checkIn: serviceType === 'airbnb'
        ? 'common.entry'
        : 'search.search-homepage.date-entry',

      checkOut: serviceType === 'airbnb'
        ? 'common.departure'
        : 'search.search-homepage.date-departure',
      comments: 'common.comments',
      people: serviceType === 'airbnb'
        ? 'airbnb.custom.request.guests'
        : 'hotel.people',
      rooms: 'hotel.custom.rooms',
      holder: 'common.holder',
      locator: 'my-bookeds.train-flight.locator',
      type: serviceType === 'expense' ? 'expenses.type' : 'common.type',
      timeDepart: 'custom-service.train-flight.departure',
      observations: 'common.observations',
      oneWay: 'my-bookeds.flight.one-way',
      pnr: 'my-bookeds.train-flight.locator',
      providerUuid: 'my-bookeds.view.provider',
      travelName: 'project.project',
      customCode: 'common.custom-code',
      costCenter: 'common.cost-center',
      supplierInvoice: 'common.supplier-invoice',
      bookType: 'common.book-type',
      invoiced: 'common.invoiced',
      paymentCard: 'common.payment-card',
      departureCarrier: 'train.form-train.departureCarrier',
      returnCarrier: 'train.form-train.returnCarrier',
      departureAirline: 'flight.result-flight.departureAirline',
      returnAirline: 'flight.result-flight.returnAirline',
      insurance: 'common.insurance',
      freeTaxes: serviceType === 'car'
        ? 'car.free-taxes'
        : 'expenses.freeTaxes',
      price: serviceType === 'expense'
        ? 'expenses.price'
        : serviceType === 'airbnb'
          ? 'airbnb.create-airbnb.price'
          : `${serviceType}.form-${serviceType}.price`,
      amount: serviceType === 'expense'
        ? 'expenses.price'
        : `${serviceType}.form-${serviceType}.price`,
      wholesalePrice: 'company.company-booked.wholesale-price',
      wholesaleAmount: 'company.company-booked.wholesale-price',
      beginDate: 'authorization.labels.from',
      endDate: 'authorization.labels.to',
      marketingFee: 'my-bookeds.view.marketing-fee',
      city: serviceType === 'airbnb'
        ? 'airbnb.create-airbnb.ubication'
        : 'common.city',
      link: 'airbnb.custom.request.link',
      travelers: serviceType === 'airbnb'
        ? 'airbnb.custom.request.guests'
        : 'common.traveller',
      departmentUuid: serviceType === 'user'
        ? 'user.form.group'
        : 'authorization.labels.group',
      provider: 'my-bookeds.view.provider',
      file: serviceType === 'user'
        ? 'common.upload-image'
        : 'common.choose-file',
      pickupPlaceFrom: 'car.custom.request.pickup.titleFrom',
      pickupPlaceTo: 'car.custom.request.pickup.titleTo',
      age: 'car.custom.request.age',
      carType: 'car.custom.request.carType.title',
      insuranceWithExcess: 'car.insuranceWithExcess',
      traveler: 'common.traveller',
      hotel: 'hotel.custom.hotel-name',
      roomType: 'search.search-booked.room-type',
      boardType: 'my-bookeds.view.rules',
      defaultTraveler: 'common.traveller',
      guests: serviceType === 'airbnb'
        ? 'airbnb.custom.request.guests'
        : 'hotel.people',
      images: 'airbnb.custom.request.images',
      agencyUuid: 'common.agency',
      planUuid: 'common.contract',
      name: 'common.name',
      company: 'company.name',
      'company.uuid': 'company.name',
      stars: 'common.stars',
      'filters.stars': 'common.stars',
      priceMin: 'common.policies.hotel-price',
      priceMax: 'common.policies.hotel-price',
      'filters.priceMin': 'common.policies.hotel-price',
      'filters.priceMax': 'common.policies.hotel-price',
      priceMinFlight: 'common.policies.flight-price',
      priceMaxFlight: 'common.policies.flight-price',
      'filters.priceMinFlight': 'common.policies.flight-price',
      'filters.priceMaxFlight': 'common.policies.flight-price',
      lodgingType: 'group.group-form.room-type',
      'filters.lodgingType': 'group.group-form.room-type',
      trainClassType: 'common.policies.train-type',
      'filters.trainClassType': 'common.policies.train-type',
      trainMaxBudgetPercentage: 'common.policies.train-budget',
      'filters.trainMaxBudgetPercentage': 'common.policies.train-budget',
      breakfast: 'common.breakfast',
      'filters.breakfast': 'common.breakfast',
      requestBooked: 'group.group-form.book-allowed',
      'filters.requestBooked': 'group.group-form.book-allowed',
      requestFlight: 'group.group-form.flight-allowed',
      flight: 'group.group-form.flight-allowed',
      'filters.requestFlight': 'group.group-form.flight-allowed',
      requestTrain: 'group.group-form.train-allowed',
      train: 'group.group-form.train-allowed',
      'filters.requestTrain': 'group.group-form.train-allowed',
      requestCar: 'common.car',
      'filters.requestCar': 'common.car',
      onlyAuthorization: 'common.policies.only-auth-hotel',
      'filters.onlyAuthorization': 'common.policies.only-auth-hotel',
      onlyFlightAuthorization: 'common.policies.only-auth-flight',
      'filters.onlyFlightAuthorization': 'common.policies.only-auth-flight',
      onlyTrainAuthorization: 'common.policies.only-auth-train',
      'filters.onlyTrainAuthorization': 'common.policies.only-auth-train',
      requestCustomBooking: 'common.policies.custom-hotel',
      'filters.requestCustomBooking': 'common.policies.custom-hotel',
      requestCustomAirbnb: 'common.policies.custom-airbnb',
      'filters.requestCustomAirbnb': 'common.policies.custom-airbnb',
      requestCustomFlight: 'common.policies.custom-flight',
      'filters.requestCustomFlight': 'common.policies.custom-flight',
      requestCustomTrain: 'common.policies.custom-train',
      'filters.requestCustomTrain': 'common.policies.custom-train',
      hotelDaysInAdvance: 'common.policies.days-advance-hotel',
      'filters.hotelDaysInAdvance': 'common.policies.days-advance-hotel',
      flightDaysInAdvance: 'common.policies.days-advance-flight',
      'filters.flightDaysInAdvance': 'common.policies.days-advance-flight',
      trainDaysInAdvance: 'common.policies.days-advance-train',
      'filters.trainDaysInAdvance': 'common.policies.days-advance-train',
      allowAmountOverDuration: 'common.policies.duration-flight',
      'filters.allowAmountOverDuration': 'common.policies.duration-flight',
      'allowAmountOverDuration.amount': 'common.policies.price-until',
      'allowAmountOverDuration.duration': 'common.policies.max-duration',
      'filters.allowAmountOverDuration.amount': 'common.policies.price-until',
      'filters.allowAmountOverDuration.duration': 'common.policies.max-duration',
      pricesByLocation: 'group.group-form.price-location',
      'filters.pricesByLocation': 'group.group-form.price-location',
      'filters.pricesByLocation.placeName': 'group.group-form.location',
      'filters.pricesByLocation.priceMax': 'group.group-form.price-location',
      users: 'common.assign-to-users',
      departments: 'common.department',
      assignToAll: 'common.all-option',
      cif: 'common.cif',
      postalCode: 'common.postal-code',
      country: 'common.country',
      province: 'common.province',
      bookedWithoutCard: 'company.company-form.allow_book_without_card',
      hotelComission: 'common.hotelComission',
      hotelDiscount: 'common.hotelDiscount',
      trainComission: 'common.trainComission',
      localFlightDiscount: 'common.local-flight-discount',
      europeFlightDiscount: 'common.europe-flight-discount',
      internationalFlightDiscount: 'common.international-flight-discount',
      flightDiscount: 'common.flightDiscount',
      'flightDiscount.local': 'common.local-flight-discount',
      'flightDiscount.europe': 'common.europe-flight-discount',
      'flightDiscount.international': 'common.international-flight-discount',
      showCommissions: 'company.company-form.show-comissions',
      suppliers: 'company.suppliers.title',
      cian: 'common.cian',
      hubUuid: 'common.hub',
      cardHolderName: serviceType === 'hub'
        ? 'hub.card.card-holder-name'
        : 'agency.card.card-holder-name',
      paNumber: serviceType === 'hub'
        ? 'hub.card.paNumber'
        : 'agency.card.paNumber',
      cvc2: serviceType === 'hub'
        ? 'hub.card.cvc2'
        : 'agency.card.cvc2',
      dateMonth: serviceType === 'hub'
        ? 'hub.card.expiration'
        : 'agency.card.expiration',
      dateYear: serviceType === 'hub'
        ? 'hub.card.expiration'
        : 'agency.card.expiration',
      discount: 'common.discount',
      'cardData.cardHolderName': serviceType === 'hub'
        ? 'hub.card.card-holder-name'
        : 'agency.card.card-holder-name',
      'cardData.paNumber': serviceType === 'hub'
        ? 'hub.card.paNumber'
        : 'agency.card.paNumber',
      'cardData.cvc2': serviceType === 'hub'
        ? 'hub.card.cvc2'
        : 'agency.card.cvc2',
      'cardData.dateMonth': serviceType === 'hub'
        ? 'hub.card.expiration'
        : 'agency.card.expiration',
      'cardData.dateYear': serviceType === 'hub'
        ? 'hub.card.expiration'
        : 'agency.card.expiration',
      billingData: 'common.billing-title',
      'billingData.identificator': 'common.identificator',
      'billingData.businessName': 'common.business',
      'billingData.address': 'common.address',
      'billingData.town': 'common.city',
      'billingData.city': 'common.city',
      'billingData.province': 'common.province',
      'billingData.postalCode': 'common.postal-code',
      'billingData.country': 'common.country',
      'traveller.name': 'common.name',
      'traveller.renfeCard': 'my-bookeds.train-flight.renfe-card',
      'traveller.surname': 'common.lastname',
      'traveller.lastname': 'common.lastname',
      'roomsInfo.files': 'common.choose-file',
      'paymentCard.name': 'common.payment-card',
      'paymentCard.token': 'common.payment-card',
      'travellers.uuid': 'common.traveller',
      'travellers.price': `${serviceType}.form-${serviceType}.price`,
      'travellers.wholesalePrice': 'company.company-booked.wholesale-price',
      'travellers.class': 'common.class-flight',
      'travellers.extras': 'flight.form-flight.extras',
      'travellers.providerUuid': 'my-bookeds.view.provider',
      'travellers.freeTaxes': 'expenses.freeTaxes',
      'travellers.seat': 'my-bookeds.train-flight.seat',
      'travellers.files': 'common.choose-file',
      'roomsInfo.price': 'company.company-booked.booked-price',
      'roomsInfo.wholesalePrice': 'company.company-booked.wholesale-price',
      'roomsInfo.roomType': 'search.search-booked.room-type',
      'roomsInfo.boardType': 'my-bookeds.view.rules',
      'roomsInfo.freeTaxes': 'expenses.freeTaxes',
      'roomsInfo.providerUuid': 'my-bookeds.view.provider',
      'roomsInfo.marketingFee': 'my-bookeds.view.marketing-fee',
      'roomsInfo.filesCount': 'common.choose-file',
      'roomsInfo.provider': 'my-bookeds.view.provider',
      'travelersPerRoom.roomNumber': 'hotel.room',
      'travelersPerRoom.travelers': 'hotel.people-per-room',
      'travelersPerRoom.travelers.uuid': 'common.traveller',
      'travelersPerRoom.travelers.name': 'common.name',
      'travelersPerRoom.travelers.lastname': 'common.lastname',
      lastname: 'user.form.surname',
      surname: 'user.form.surname',
      email: 'common.email',
      phone: 'user.form.phone',
      group: 'user.form.group',
      department: 'user.form.group',
      travelPolicyUuid: 'group.group-form.travel-policies',
      policyUuid: 'group.group-form.travel-policies',
      identificationType: 'user.form.documentType',
      documentType: 'user.form.documentType',
      dni: 'user.form.dni',
      nie: 'user.form.nie',
      passport: 'user.form.passport',
      dniIssuanceDate: 'user.form.dniIssuanceDate',
      dniExpirationDate: 'user.form.dniExpirationDate',
      nieIssuanceDate: 'user.form.nieIssuanceDate',
      nieExpirationDate: 'user.form.nieExpirationDate',
      passportIssuanceDate: 'user.form.passportIssuanceDate',
      passportExpires: 'user.form.passportExpires',
      birthdate: 'user.form.birthdate',
      gender: 'user.form.gender',
      resident: 'user.form.resident',
      nationality: 'user.form.nationality',
      currentCountry: 'user.form.currentCountry',
      passportCountryEmitter: 'user.form.passportCountryEmitter',
      employeeNumber: 'user.form.employeeNumber',
      renfeCard: 'my-bookeds.train-flight.renfe-card',
      ffCard: 'my-bookeds.train-flight.ff-card',
      'ffCard.cardName': 'my-bookeds.train-flight.ff-card',
      'ffCard.cardNumber': 'my-bookeds.train-flight.ff-card',
      paymentCards: 'common.payment-card',
      'paymentCards.name': 'common.payment-card',
      'paymentCards.token': 'common.payment-card',
      isGroupAdmin: 'user.form.is-group-manager',
      isManager: 'user.form.is-manager',
      isAgencyAdmin: 'common.agency-admin',
      isHubAdmin: 'common.hub-admin',
      isEmployee: 'user.form.is-employee',
      doCheckIn: 'user.form.do-checkin',
      notifications: 'user.notifications.title',
      'notifications.company': 'user.notifications.company',
      'notifications.group': 'user.notifications.group',
      'notifications.user': 'user.notifications.user',
      image: 'common.upload-image',
    };

    const translationKey = fieldTranslationMap[normalizedField];

    if (!translationKey) {
      return this.humanizeValidationField(field);
    }

    return this.instantOrFallback(
      translationKey,
      this.humanizeValidationField(field)
    );
  }

  normalizeValidationField(field: string): string {
    if (!field) {
      return '';
    }

    return field
      .replace(/\[(\d+)\]/g, '.$1')
      .replace(/travellers\.\d+\./, 'travellers.')
      .replace(/roomsInfo\.\d+\./, 'roomsInfo.')
      .replace(/travelersPerRoom\.\d+\.travelers\.\d+\./, 'travelersPerRoom.travelers.')
      .replace(/travelersPerRoom\.\d+\./, 'travelersPerRoom.')
      .replace(/pricesByLocation\.\d+\./, 'pricesByLocation.')
      .replace(/ffCard\.\d+\./, 'ffCard.')
      .replace(/paymentCards\.\d+\./, 'paymentCards.')
      .replace(/paymentCard\.\d+\./, 'paymentCard.');
  }

  humanizeValidationField(field: string): string {
    if (!field) {
      return this.translate.instant('common.field');
    }

    const cleanField = field
      .replace(/\[(\d+)\]/g, '.$1')
      .replace(/travellers\.\d+\./, '')
      .replace(/\.\d+\./g, '.')
      .split('.')
      .pop();

    return cleanField || field;
  }

  getValidationErrorsMessage(validationErrors: any[], type?: string): string {
    return validationErrors
      .map((e) => `• ${this.getValidationErrorMessage(e, type)}`)
      .filter(Boolean)
      .join('<br>');
  }

  private instantOrFallback(key: string, fallback: string, params?: any): string {
    const translated = this.translate.instant(key, params);

    return translated === key ? fallback : translated;
  }

  formatDate(date): Date {
    return new Date(date.year, date.month - 1, date.day);
  }

  combineDateAndTime(date: any, time): string | null {
    if (!date || !time) return null;

    const { year, month, day } = date;
    const { hour, minute } = time;

    const fullDate = new Date(year, month - 1, day, hour, minute);
    return fullDate.toLocaleString("sv-SE").replace(" ", "T");;
  }
}
